import { useContext } from 'react';
import { useSelector } from 'react-redux';
import TransitChargeState from '~/constants/TransitChargeState';
import DiscountContext from '~/context/common/DiscountContext';
import { useConfiguration } from '~/context/common/StaticContext';
import {
  getShowEVTaxTreatment,
  getTransitChargeInfo,
  getVehicleDetails
} from '~/selectors';

export default function useGetShowEVTaxTreatment() {
  const { EvTaxCreditTagConfig: evTaxCreditTagConfig } = useConfiguration();
  const showEVTaxTreatment = useSelector(getShowEVTaxTreatment);
  const { highlights, price = 0 } = useSelector(getVehicleDetails);
  const {
    totalDiscount,
    discounts: { isLoaded: isDiscountsLoaded }
  } = useContext(DiscountContext);

  const {
    data: transitCharge,
    isLoaded: isTransitChargeLoaded,
    state
  } = useSelector(getTransitChargeInfo);

  if (!evTaxCreditTagConfig) {
    return false;
  }

  const { evTaxCreditTagId, isUsingThreshold, maxPriceThreshold } =
    evTaxCreditTagConfig;
  const meetsThreshold =
    price + transitCharge - totalDiscount <= maxPriceThreshold;
  const hasEvTag =
    highlights?.some(
      highlight => highlight.tagId.toString() === evTaxCreditTagId
    ) ?? false;

  if (isUsingThreshold && hasEvTag) {
    if (price <= 22500) {
      return true;
    } else {
      return state === TransitChargeState.Unknown
        ? false
        : meetsThreshold && isTransitChargeLoaded && isDiscountsLoaded;
    }
  } else {
    return showEVTaxTreatment;
  }
}
